<script	setup>
import Modal from '@/Pages/sharedComponents/modal.vue';

const props = defineProps({
	text: String
})
const id = 'familyWelcome'
</script>

<template>
	<Modal :id="id" :hasDontShowAnymore="true">
		<article
			v-html="$tg('welcomeModal')"
		/>

		<div class="btn w-2/3 mt-8 bg-white text-blue"
			data-micromodal-close aria-label="Close modal">
			{{ $tg('continue')}}
		</div>
	</Modal>
</template>
